import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=76ee2aa9&"
import script from "./Model.vue?vue&type=script&lang=js&"
export * from "./Model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\immersive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ee2aa9')) {
      api.createRecord('76ee2aa9', component.options)
    } else {
      api.reload('76ee2aa9', component.options)
    }
    module.hot.accept("./Model.vue?vue&type=template&id=76ee2aa9&", function () {
      api.rerender('76ee2aa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Model.vue"
export default component.exports